import axios from "~/plugins/axios";

export default {
  getByEmailId(emailId) {
    return axios.get(`/web_api/v1/email_event/by_email/${emailId}`).then((response) => response.data);
  },
  getByEmailIdGroupedByType(emailId) {
    return axios.get(`/web_api/v1/email_event/by_email_grouped_by_type/${emailId}`).then((response) => response.data);
  },
};
